import { render, staticRenderFns } from "./HospitalHeader.vue?vue&type=template&id=56827575"
import script from "./HospitalHeader.vue?vue&type=script&lang=ts"
export * from "./HospitalHeader.vue?vue&type=script&lang=ts"
import style0 from "./HospitalHeader.vue?vue&type=style&index=0&id=56827575&prod&lang=sass"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports